"use client";

import dynamic from "next/dynamic";

/**
 * The editor renders client-only. It's a fully interactive canvas app whose
 * server markup would be discarded on hydration anyway, and skipping SSR
 * lets it restore locally-saved work in a plain state initializer instead
 * of a post-mount effect that flashes the preset first. The picker page
 * stays server-rendered — that's the page worth indexing.
 */
const EditorShell = dynamic(
  () => import("@/components/editor/EditorShell").then((m) => m.EditorShell),
  { ssr: false },
);

export function EditorClient({ artworkId }: { artworkId?: string }) {
  return <EditorShell artworkId={artworkId} />;
}
